import { createStore } from "vuex";

const store = createStore({
  state: {
    tags: [],
    recentSearches: [],
    favorites: [],
    selectedIndex: -1,
    isSearchModalOpen: false,
  },
  mutations: {
    addTag(state, tag) {
      state.tags.push(tag);
    },
    removeTag(state, index) {
      state.tags.splice(index, 1);
    },
    clearTags(state) {
      state.tags = [];
    },
    addToRecent(state, search) {
      // Controlla se 'search' è un array o una singola stringa
      const searches = Array.isArray(search) ? search : [search]; // Se è una stringa, la converte in un array

      searches.forEach((item) => {
        if (!state.recentSearches.includes(item)) {
          state.recentSearches.unshift(item);
          if (state.recentSearches.length > 5) {
            state.recentSearches.pop(); // Limita a 5 elementi
          }
        }
      });
    },

    addToFavourites(state, search) {
      const searches = Array.isArray(search) ? search : [search]; // Controlla se è un array

      searches.forEach((item) => {
        if (!state.favorites.includes(item)) {
          state.favorites.unshift(item);
          if (state.favorites.length > 5) {
            state.favorites.pop(); // Limita a 5 elementi
          }
        }
      });
    },
    toggleFavorite(state, search) {
      const index = state.favorites.findIndex((fav) => fav === search);
      if (index === -1) {
        state.favorites.unshift(search);
        if (state.favorites.length > 5) {
          state.favorites.pop();
        }
      } else {
        state.favorites.splice(index, 1);
      }
    },
    setSelectedIndex(state, index) {
      state.selectedIndex = index;
    },
    setSearchOpen(state, value) {
      state.isSearchModalOpen = value;
    },
  },
  getters: {
    getTagType: () => (text) => {
      if (text.startsWith("D_")) return "bet_id";
      if ((text.match(/-/g) || []).length >= 3) return "round_id";
      return "user_id";
    },
  },
});

export default store;
